import { defineMessages } from "react-intl";

export default defineMessages({
  // paymentComponentBuyNow: {
  //     id: 'integration.quoteandbind.directives.custom-quote.BOP.BuyNow',
  //     defaultMessage: 'BuyNow'
  // },
  // paymentSource: {
  //     id: 'amp.bc3.directives.templates.payment-instrument-bc3.Source',
  //     defaultMessage: 'Source'
  // },
  // bankAccountSource: {
  //     id: 'amp.bc3.directives.templates.payment-instrument-bc3.Bank Account',
  //     defaultMessage: 'Bank Account'
  // },
  // cardIssuer: {
  //     id: 'platform.paymentdetails.credit-card-auto-details.Card Issuer',
  //     defaultMessage: 'Card Issuer',
  // },
  // selectIssuer: {
  //     id: 'platform.paymentdetails.credit-card-auto-details.-- Please Select --',
  //     defaultMessage: '-- Please Select --'
  // },
  // paymentMethod: {
  //     id: 'quoteandbind.views.payment-details.Payment Method',
  //     defaultMessage: 'Payment Method',
  // },
  // bankAccount: {
  //     id: 'quoteandbind.views.payment-details.Bank Account',
  //     defaultMessage: 'Bank Account',
  // },
  // creditCard: {
  //     id: 'quoteandbind.views.payment-details.Credit Card',
  //     defaultMessage: 'Credit Card',
  // },
  // accountType: {
  //     id: 'quoteandbind.directives.templates.bank-account-details-quote.Account Type',
  //     defaultMessage: 'Account Type',
  // },
  // accountNumber: {
  //     id: 'quoteandbind.directives.templates.bank-account-details-quote.Account Number',
  //     defaultMessage: 'Account Number',
  // },
  // routingNumber: {
  //     id: 'quoteandbind.directives.templates.bank-account-details-quote.Routing (ABA) Number',
  //     defaultMessage: 'Routing (ABA) Number',
  // },
  // bankName: {
  //     id: 'quoteandbind.directives.templates.bank-account-details-quote.Bank Name',
  //     defaultMessage: 'Bank Name',
  // },
  cancel: {
    id: "directives.templates.payment-method.Cancel",
    defaultMessage: "Cancel",
  },
  paymentMethod: {
    id: "directives.templates.payment-method.Payment Method",
    defaultMessage: "Payment Method",
  },
  withdrawalDayOfMonth: {
    id: "directives.templates.payment-method.Withdrawal Day of Month",
    defaultMessage: "Withdrawal Day of Month",
  },
  changePaymentMethod: {
    id: "directives.templates.payment-method.Change Payment Method",
    defaultMessage: "Change Payment Method",
  },
  Add: {
    id: "directives.templates.payment-method.Add",
    defaultMessage: "Add",
  },
  modelError: {
    id: 'directives.templates.payment-method.Error',
    defaultMessage: 'Error'
},
paymentListError: {
    id: 'directives.templates.payment-method.Unable to get Payment list. Please contact administrator',
    defaultMessage: 'Unable to get Payment list. Please contact administrator'
},
billingMethodChangeError: {
    id: 'directives.templates.payment-method.Unable to save billing method changes. Please contact system administrator',
    defaultMessage: 'Unable to save billing method changes. Please contact system administrator'
},
creditCardError: {
    id: 'directives.templates.payment-method.Credit Card Error',
    defaultMessage: 'Credit Card Error'
},
creditCardEmptyError: {
    id: 'directives.templates.payment-method.Please fill all credit card details',
    defaultMessage: 'Please fill all credit card details'
},
paymentStatus: {
    id: 'directives.templates.payment-method.Payment Status',
    defaultMessage: 'Payment Status'
},
paymentAddedSuccessfully: {
    id: 'directives.templates.payment-method.Payment Added Successfully',
    defaultMessage: 'Payment Added Successfully'
},
paymentAddFailure: {
    id: 'directives.templates.payment-method.Payment Add Failure',
    defaultMessage: 'Payment Add Failure'
},
bankdetailsEmptyError: {
    id: 'directives.templates.payment-method.Please fill bank details',
    defaultMessage: 'Please fill bank details'
},
instituteSearchError: {
    id: 'directives.templates.payment-method.Error occurred while searching',
    defaultMessage: 'Error occurred while searching'
},
instituteSearchErrorDetails: {
    id: 'directives.templates.payment-method.Error occurred while searching bank information. Please try after sometime.',
    defaultMessage: 'Error occurred while searching bank information. Please try after sometime.'
},
});
